import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Testimonials />
        <About />
        <Services />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}